import { useState } from "react";

const useWx = function (): wx {
    // @ts-ignore
    const [wx$] = useState(wx);
    return wx$;
}

export { useWx };
